import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, plan, onConfirm }) => {
  if (!isOpen || !plan) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full bg-destructive/20 flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                Delete Plan
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                Are you sure you want to delete the <span className="font-semibold text-foreground">{plan?.name}</span> plan?
              </p>
            </div>
          </div>

          <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md mb-6">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} color="var(--color-destructive)" className="flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-destructive font-body">
                  This action cannot be undone
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  {plan?.subscribers > 0 ? (
                    <>
                      <span className="font-semibold">{plan?.subscribers} active subscribers</span> will be affected. Consider migrating them to another plan first.
                    </>
                  ) : (
                    'This plan has no active subscribers.'
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              size="lg"
              onClick={onConfirm}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Delete Plan
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;